import React, { useState } from "react";

const FAQ = () => {
  // Blocos de perguntas e respostas
  const faqBlocks = [
    {
      title: "Sobre a IMO Investimentos",
      questions: [

        {
          question: "Quem pode investir com a IMO? Preciso morar em Portugal?",
          answer:
            "Qualquer pessoa física ou jurídica pode investir com a IMO, independentemente de residir em Portugal. Facilitamos investimentos para brasileiros e investidores globais, garantindo um processo simples e seguro.",
        },

          {
            question: "A IMO é uma empresa registrada e legalmente regulamentada?",
            answer:
              "Sim, a IMO é uma empresa legalmente registrada e regulamentada, operando com total conformidade às leis portuguesas e europeias, através da sua holding Molteplici Imóveis <NIPC: 517.880.547>.",
          },
      ],
    },
    {
      title: "Sobre os Investimentos",
      questions: [

          {
            question: "Quais são os riscos envolvidos nos investimentos da IMO?",
            answer:
              "Embora minimizados, os riscos incluem atrasos na venda ou finalização de projetos. Reduzimos esses impactos com análises detalhadas, garantias jurídicas e acompanhamento próximo. Os riscos financeiros são os normais existentes em qualquer investimento com potencial de lucratividade como os projetos da IMO.",
          },
          {
            question: "É possível diversificar entre diferentes tipos de projetos?",
            answer:
              "Sim, oferecemos a possibilidade de investir em diferentes projetos simultaneamente, diversificando sua carteira e reduzindo riscos.",
          },
          
      ],
    },
    {
      title: "Sobre o Processo",
      questions: [
       
          {
            question: "É possível investir de forma compartilhada com outros investidores?",
            answer: "Sim, oferecemos opções de co-investimento, permitindo que você participe de projetos maiores com outros investidores.",
          },
      ],
    },
   
  ];

  // Estado para controlar o item ativo
  const [activeIndex, setActiveIndex] = useState(null);

  // Função para alternar o acordeão
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div
      className="faq-container mt-5"
      style={{ maxWidth: "800px", margin: "0 auto" }}
    >
      {faqBlocks.map((block, blockIndex) => {
        // Controle da numeração global
        const startNumber = faqBlocks
          .slice(0, blockIndex)
          .reduce((acc, b) => acc + b.questions.length, 0);

        return (
          <div key={blockIndex}>
           
            {block.questions.map((faq, questionIndex) => {
              const globalIndex = startNumber + questionIndex + 1; // Numeração global
              return (
                <div
                  key={globalIndex}
                  style={{
                    borderBottom: "1px solid #ccc",
                    marginBottom: "10px",
                    paddingBottom: "10px",
                  }}
                >
                  {/* Título da Pergunta */}
                  <div
                    className="mx-4"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      cursor: "pointer",
                      padding: "10px 0",
                      color: "#e9e9e9",
                    }}
                    onClick={() => toggleAccordion(globalIndex)}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span
                        style={{
                          marginRight: "10px",
                          fontWeight: "bold",
                          fontSize: "18px",
                          color: "#ECA600",
                        }}
                      >
                        {globalIndex}.
                      </span>
                      <span style={{ fontSize: "16px", fontWeight: "" }}>
                        {faq.question}
                      </span>
                    </div>
                    <span>
                      {activeIndex === globalIndex ? (
                        // Ícone da seta para cima
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="18"
                          width="18"
                          viewBox="0 0 448 512"
                        >
                          <path
                            fill="#ECA600"
                            d="M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
                          />
                        </svg>
                      ) : (
                        // Ícone da seta para baixo
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="18"
                          width="18"
                          viewBox="0 0 448 512"
                        >
                          <path
                            fill="#ECA600"
                            d="M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"
                          />
                        </svg>
                      )}
                    </span>
                  </div>

                  {/* Resposta */}
                  {activeIndex === globalIndex && (
                    <div className="text-start"
                      style={{
                        paddingLeft: "28px",
                        fontSize: "14px",
                        color: "#9e9e9e",
                      }}
                    >
                      {faq.answer}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default FAQ;
